'use client';

import type { LinkProps as MuiLinkProps } from '@mui/material/Link';
import { createTheme } from '@mui/material/styles';
import { LinkBehavior } from './LinkBehavior';

const theme = createTheme({
    cssVariables: true,
    palette: {
        mode: 'light',
        primary: {
            main: '#223a5c',
        },
        secondary: {
            main: '#84c450',
        },
        background: {
            default: '#fff',
        },
    },
    typography: {
        fontFamily: 'var(--font-poppins)',
    },
    components: {
        MuiLink: {
            defaultProps: {
                component: LinkBehavior,
            } as MuiLinkProps,
        },
        MuiButtonBase: {
            defaultProps: {
                LinkComponent: LinkBehavior,
            },
        },
        MuiStack: {
            defaultProps: {
                useFlexGap: true,
            },
        },
        MuiAlertTitle: {
            styleOverrides: {
                root: {
                    fontWeight: 'bold',
                },
            },
        },
        MuiBreadcrumbs: {
            styleOverrides: {
                root: {
                    fontSize: '1em',
                },
                separator: {
                    fontSize: '1em',
                },
                li: {
                    '&, & a, & span': {
                        fontSize: '1em',
                    },
                },
            },
        },
    },
});

export default theme;
